import { lazy } from "react";

// project imports
import MainLayout from "../layout/MainLayout";
import Loadable from "../components/Loadable";

// dashboard routing
const Dashboard = Loadable(lazy(() => import("../pages/Dashboard/index.js")));

// services routing
const StockOrder = Loadable(lazy(() => import("../pages/StockOrder")));
const OpenPositions = Loadable(lazy(() => import("../pages/OpenPositions")));
const ClosedPositions = Loadable(lazy(() => import("../pages/ClosedPositions")));
const PendingOrders = Loadable(lazy(() => import("../pages/PendingOrders")));

const ServicesScripts = Loadable(lazy(() => import("../pages/Scripts")));

// social routing
const MyProfilePage = Loadable(lazy(() => import("../pages/Profile")));
const FriendProfilePage = Loadable(lazy(() => import("../pages/Profile/FriendProfilePage")));
const Settings = Loadable(lazy(() => import("../pages/Settings")));
const Friends = Loadable(lazy(() => import("../pages/Friends")));
const Discussion = Loadable(lazy(() => import("../pages/Discussion")));

const SocialLeaderboard = Loadable(lazy(() => import("../pages/Leaderboard")));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: "/",
    element: <MainLayout />,
    children: [
        {
            path: "/dashboard",
            element: <Dashboard />,
        },
        {
            path: "services",
            children: [
                {
                    path: "portfolio",
                    children: [
                        {
                            path: "stock-order",
                            element: <StockOrder />,
                        },
                        {
                            path: "open-positions",
                            element: <OpenPositions />,
                        },
                        {
                            path: "pending-orders",
                            element: <PendingOrders />,
                        },
                        {
                            path: "closed-positions",
                            element: <ClosedPositions />,
                        },
                    ],
                },
                {
                    path: "scripts",
                    element: <ServicesScripts />,
                },
            ],
        },
        {
            path: "social",
            children: [
                {
                    path: "social-hub",
                    children: [
                        {
                            path: "profile/my-profile",
                            element: <MyProfilePage />,
                        },
                        {
                            path: "profile/:userId",
                            element: <FriendProfilePage />,
                        },
                        {
                            path: "friends",
                            element: <Friends />,
                        },
                        {
                            path: "discussion",
                            element: <Discussion />,
                        },
                    ],
                },
                {
                    path: "leaderboard",
                    element: <SocialLeaderboard />,
                },
            ],
        },
        {
            path: "settings",
            element: <Settings />,
        },
    ],
};

export default MainRoutes;
